import React from 'react';
import { AbstractToggleListProps } from './types';

export class AbstractToggleList<T extends AbstractToggleListProps> extends React.PureComponent<AbstractToggleListProps | T> {

  onChange = (...args: any) => this.props.onChange(...args);

  isValueSelected(value: string): boolean {
    throw new Error('not implemented');
  }

  render() {
    const { containerComponent: Container, items, renderItem } = this.props;

    return (
      <Container>
        {items.map((item) =>
          renderItem({
            item,
            key: item.value,
            checked: this.isValueSelected(item.value),
            onChange: this.onChange
          })
        )}
      </Container>
    );
  }
}
